<template>
     <div id="occupancychart"></div>  
</template>

<script>
import ApexCharts from 'apexcharts'
export default {
    props: {
        userUtilization: {
            type: Number,
            default: 0
        },
        companyUtilization: {
            type: Number,
            default: null
        },
    },
    mounted() {
        let userUtilization = this.userUtilization;
        let ut = [userUtilization];
        if(this.companyUtilization) ut.push(this.companyUtilization);

        let dataLabels = {
            total: {
                show: true,
                label: 'Beläggningsgrad',
                formatter: function (w) {
                    return `${userUtilization}%`;
                }
            }
        }

        var options = {
            series: ut,
            chart: {
                height: 350,
                type: 'radialBar',
            },
            plotOptions: {
                radialBar: {
                    hollow: {
                        size: '70%',
                    },
                },
            },
            labels: ['Beläggningsgrad personlig', 'Beläggningsgrad företag'],
            fill: {
                colors: [function({ value }) {
                    if(value < 65) {
                        return '#CD6155'
                    } else if (value >= 65 && value < 85) {
                        return '#F5B041'
                    } else if (value >= 85 && value < 90) {
                        return '#58D68D'
                    } else {
                        return '#52BE80'
                    }
                }]
            },
        };

        if(this.companyUtilization) options.plotOptions.radialBar.dataLabels = dataLabels;

        var chart = new ApexCharts(document.querySelector("#occupancychart"), options);
        chart.render();
    },

}
</script>

<style>

</style>